import { z } from 'zod';

export const OnboardingPeerGroupQueryParamsSchema = z.object({
    // asset: z.string(),
    plugin: z.optional(z.string()),
});
